import React, { useState } from "react";
import {
  Box,
  Typography,
  Drawer,
  Stack,
  Button,
  ListItem,
  List,
} from "@mui/material";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { profileUpdate } from "../../appStore/actions/profile/action";
import { crossIcon, crossIconDiv } from "../../assets/commonFunction";
import { useTranslation } from "react-i18next";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth:"31.25rem",
    height: "100%",
  },
  header: {
    // backgroundColor: '#183243',
    backgroundColor: "#F9F8F8",
    color: "#000000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const FirstGroupToolTip = ({ updateKey }) => {
    const { t } = useTranslation();
    const appContent = t("AppContent", { returnObjects: true });
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const dispatch = useDispatch();
  const handleDone = () => {
    setDrawerOpen(false);
    dispatch(profileUpdate({ [updateKey]: true }, false));
  };
  return (
    <Drawer sx={{ zIndex: 1202 }} open={isDrawerOpen} anchor="right">
      <Box sx={classes.drawerBody}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={classes.header}
        >
          <Typography onClick={handleDone} sx={classes.iconDiv}>
            <CloseIcon sx={classes.iconn} />
          </Typography>
          <Typography>Tooltip</Typography>
        </Stack>

        <Box width={"95%"} margin={"auto"} padding={"0rem 0.5rem"}>
          <Typography fontSize={"0.875rem"} fontWeight={600} mb={"0.8rem"}>Welcome to Arkchat</Typography>

          <Typography fontSize={"0.875rem"} mb={"0.8rem"}>
            {appContent?.KEY366}
          </Typography>

          <Box idth={"90%"} margin={"auto"}>
          <Typography fontSize={"0.875rem"}>
            {appContent?.KEY367}
          </Typography>
            <List
              sx={{
                listStyleType: "disc",
                pl: 2,
                "& .MuiListItem-root": {
                  display: "list-item",
                  paddingTop:"0px",
                  paddingLeft:"0px"
                },
              }}
            >
              <ListItem>
                <Typography fontSize={"0.875rem"}>
                  {appContent?.KEY368}
                </Typography>
              </ListItem>
              <ListItem>
                <Typography fontSize={"0.875rem"}>{appContent?.KEY369}</Typography>
              </ListItem>
              <ListItem>
                <Typography fontSize={"0.875rem"}> {appContent?.KEY370}</Typography>
              </ListItem>
              <ListItem>
                <Typography fontSize={"0.875rem"}> {appContent?.KEY371}</Typography>
              </ListItem>
            </List>
          </Box>

          <Typography>
           {appContent?.KEY372}{" "}
          </Typography>
        </Box>

        <Box
          textAlign={"center"}
          width={"100%"}
          position={"absolute"}
          bottom={"1.5rem"}
        >
          <Button
            onClick={handleDone}
            style={{
              background: "#FFFFFF",
              color: "#000000",
              border: "1px solid #000000",
              borderRadius: "3px",
              textTransform: "none",
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }}
            variant="contained"
          >
            Got it
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FirstGroupToolTip;
